// extracted by mini-css-extract-plugin
export default {"product-configurator-container":"ProductConfigurator_product-configurator-container__Y6vgj"};